import { render, staticRenderFns } from "./EditorDataParser.vue?vue&type=template&id=3e645795"
import script from "./EditorDataParser.vue?vue&type=script&lang=js"
export * from "./EditorDataParser.vue?vue&type=script&lang=js"
import style0 from "./EditorDataParser.vue?vue&type=style&index=0&id=3e645795&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports